import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import leaf from '../../assets/images/leaf.svg';
import ExportButton from '../../components/ExportButton';
import Button from '../../components/Button';
import { useNavigate } from 'react-router-dom';
import { DiagnosisPageUrl } from '../../url/poenUrl';
import SellerBatteryService from '../../api/service/seller/SellerBatteryService';
import {
  BatteryDamageInfoData,
  BatteryImage,
  BatteryOverviewData,
  UpdateBatteryDamageInfoBody,
} from '../../api/service/BatteryInterfaces';
import ImagePreview from '../../components/ImagePreview';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { BaseImageResponse } from '../../api/service/UtilsInterface';
import generateDiagnosisTab2PDF from './DiagnosisTab2PDF';
import LoadingOverlay from '../../components/LoadingOverlay';

const Container = styled.div`
  margin-top: 10px;
  @media (max-width: 768px) {
    margin-top: 0px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  img {
    width: 20px;
  }
`;

const Title = styled.h3`
  display: flex;
  line-height: 32px;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.textColor};

  img {
    width: 24px;
    height: 24px;
  }

  @media (max-width: 768px) {
    margin-left: 5px;
    font-size: 12px;
    line-height: 20px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  @media (max-width: 1280px) {
    display: none;
  }
`;
const ButtonContainerM = styled.div`
  display: none;
  gap: 10px;
  @media (max-width: 1280px) {
    display: flex;
  }
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  gap: 20px;
  background-color: ${(props) => props.theme.colors.grayColor};
  border-radius: 10px 10px 0 0;

  @media (max-width: 1280px) {
    flex-direction: column;
  }
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const HeaderInfoBox = styled.div`
  flex: 1;
`;

const HeaderInfoBox2 = styled.div`
  flex: 0.6;
`;

const InfoBox = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 작은 화면에서는 두 열로 표시 */
  gap: 5px; /* 간격 조정 */
  border-radius: 20px;
  padding: 20px;
  border: 2px solid ${(props) => props.theme.colors.whiteColor};

  @media (max-width: 768px) {
    padding: 10px;
    border-radius: 10px;
    grid-template-columns: repeat(2, 1fr); /* 작은 화면에서는 두 열로 표시 */
  }
`;

const InfoBox2 = styled.div`
  border-radius: 20px;
  padding: 20px 20px 29px 20px;
  border: 2px solid ${(props) => props.theme.colors.whiteColor};

  @media (max-width: 768px) {
    padding: 10px;
    border-radius: 10px;
  }
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 작은 화면에서는 두 열로 표시 */
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  label {
    text-align: right;
    font-size: 16px;
    min-width: 70px;
  }

  input {
    width: 100%;
    flex: 1;
    padding: 5px 10px;
    border: 1px solid ${(props) => props.theme.colors.grayColor};
    background-color: ${(props) => props.theme.colors.whiteColor};

    &[readonly] {
      background-color: #ebebeb;
    }
  }

  @media (max-width: 768px) {
    label {
      font-size: 10px;
      min-width: 40px;
    }

    input {
      font-size: 10px;
    }
  }
`;

const InputContainer2 = styled.div`
  display: flex;
  align-items: center;

  label {
    background-color: ${(props) => props.theme.colors.silverColor2};
    padding: 5px;
    text-align: center;
    font-size: 16px;
    min-width: 70px;
  }

  input {
    width: 100%;
    flex: 1;
    padding: 5px 10px;
    border: 1px solid ${(props) => props.theme.colors.grayColor};
    background-color: ${(props) => props.theme.colors.whiteColor};
  }

  @media (max-width: 768px) {
    label {
      font-size: 10px;
      min-width: 40px;
    }

    input {
      font-size: 10px;
    }
  }
`;

const BodySection = styled.section`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px;
  margin-bottom: 20px;
  background-color: ${(props) => props.theme.colors.whiteColor};
  @media (max-width: 1280px) {
    flex-direction: column;
  }
  @media (max-width: 768px) {
    padding: 20px 0px;
  }
`;

const BodyInfoBox = styled.section`
  flex: 1;
  width: 100%;
  height: 100%;
  border-right: 1px solid #ccc; /* Add right border only to the first item */
  margin-right: 40px;
  padding-right: 40px;

  &:not(:first-child) {
    border-right: none; /* Remove right border from all other items */
    padding-right: 0px;
    margin-right: 0px;
  }
`;

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${(props) => props.theme.colors.whiteColor};

  tr {
    border-bottom: 1px solid ${(props) => props.theme.colors.silverColor};
  }

  th,
  td {
    font-size: 16px;
    padding: 10px;
    text-align: center;
    vertical-align: middle; /* 세로 정렬 */
    white-space: nowrap; /* 줄바꿈 방지 */
  }

  th {
    background-color: ${(props) => props.theme.colors.brownColor};
    color: white;
    font-weight: 500;
  }

  th:first-child {
    border-top-left-radius: 10px;
  }

  th:last-child {
    border-top-right-radius: 10px;
  }

  @media (max-width: 768px) {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;

    th {
      background-color: ${(props) => props.theme.colors.subColor};
    }

    th,
    td {
      font-size: 12px;
      padding: 10px;
      text-align: center;
      vertical-align: middle; /* 세로 정렬 */
      white-space: nowrap; /* 줄바꿈 방지 */
    }

    th {
      font-weight: 400;
    }

    th:first-child {
      border-top-left-radius: 0px;
    }

    th:last-child {
      border-top-right-radius: 0px;
    }
  }
`;

const StatusButton = styled.span<{ $status: string }>`
  display: inline-block;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 500;
  color: black; /* 기본 글자색은 검은색 */
  border-radius: 5px;
  text-align: center;
  background-color: transparent; /* 기본 배경은 없음 */

  ${(props) =>
    props.$status === '우수' &&
    `
    background-color: #91C6B2;  // 녹색
    color: white;  // 글자색은 흰색
  `}
  ${(props) =>
    props.$status === '양호' &&
    `
    background-color: #80C1EA;  // 파란색
    color: white;  // 글자색은 흰색
  `}
  ${(props) =>
    props.$status === '미흡' &&
    `
    background-color: #FFE822;  // 노란색
    color: white;  // 글자색은 검은색
  `}
  ${(props) =>
    props.$status === '불량' &&
    `
    background-color: #FF8080;  // 빨간색
    color: white;  // 글자색은 흰색
  `}
`;

const BigImage = styled.div`
  max-height: 400px;
`;
const MainImageButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 10px 0px;
  p {
    font-size: 12px;
  }

  @media (max-width: 496px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  max-width: 766px;
  height: 100%;
`;

const ArrowButton = styled.div<{ $disabled: boolean }>`
  border-radius: 10px;
  display: flex;
  height: 160px;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.$disabled
      ? props.theme.colors.grayColor
      : props.theme.colors.subColor};
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  &:hover {
    background-color: ${(props) =>
      props.$disabled
        ? props.theme.colors.grayColor
        : props.theme.colors.subHoverColor};
  }

  svg {
    font-size: 24px;
    color: white;
  }
  @media (max-width: 696px) {
    height: 140px;
  }
  @media (max-width: 596px) {
    height: 100px;
  }
  @media (max-width: 496px) {
    height: 80px;
  }
`;

const ArrowButtonLeft = styled(ArrowButton)`
  border-radius: 10px 0px 0px 10px;
`;

const ArrowButtonRight = styled(ArrowButton)`
  border-radius: 0px 10px 10px 0px;
`;

const ImageGrid = styled.div`
  width: 100%;
  max-height: 200px; /* 최대 높이 제한 */
  display: grid;
  grid-template-columns: repeat(5, minmax(130px, 130px));
  grid-template-rows: repeat(2, 74px);

  gap: 10px;
  justify-content: center; /* 수평 가운데 정렬 */
  align-content: center; /* 수직 가운데 정렬 */

  /* 반응형 설정 */
  @media (max-width: 796px) {
    grid-template-columns: repeat(5, minmax(30px, 130px));
    grid-template-rows: repeat(2, 74px);
  }
`;

function DiagnosisTab2() {
  const navigate = useNavigate();
  const [isPDFLoading, setIsPDFLoading] = useState(false); // 로딩 상태 추가
  const [batteryId, setBatteryId] = useState<string | null>(null);
  const [batteryOverview, setBatteryOverview] = useState<BatteryOverviewData[]>(
    []
  ); // 배터리 요약 정보를 위한 상태 추가
  const [batteryDamageInfo, setBatteryDamageInfo] =
    useState<BatteryDamageInfoData | null>(null); // 배터리 정보 상태 추가
  const [batteryImages, setBatteryImages] = useState<BatteryImage[]>([]); // 이미지 상태 추가
  const [batteryImageAll, setBatteryImageAll] = useState<BatteryImage[]>([]); // 이미지 상태 추가
  const [selectedImage, setSelectedImage] = useState<BatteryImage | null>(null); // 선택된 이미지 상태
  const [representativeImage, setRepresentativeImage] =
    useState<BaseImageResponse | null>(null); // 선택된 이미지 상태
  const [imagePage, setImagePage] = useState<number>(0); // 페이지 상태 추가
  const [imageTotalPage, setImageTotalPage] = useState<number>(0); // 총 페이지 수 상태 추가
  const [batteryFormData, setBatteryFormData] =
    useState<UpdateBatteryDamageInfoBody>({
      carNo: '',
      romId: '',
      productNo: '',
      productionDate: '',
      qrcode: '',
      price: 0,
      breakage: '',
      moisture: '',
      pollution: '',
      note: '',
    });

  const MemoizedImagePreview = React.memo(ImagePreview);

  // URL에서 batteryId 값을 가져옴
  useEffect(() => {
    // 로컬스토리지에서 'DiagnosisbatteryId'를 가져옵니다.
    const storedBatteryId = sessionStorage.getItem('DiagnosisbatteryId');

    if (storedBatteryId) {
      setBatteryId(storedBatteryId); // 로컬스토리지에 값이 있으면 batteryId 상태에 저장
    } else {
      // 배터리 ID가 없으면 경고창을 띄우고 DiagnosisTab1로 돌아갑니다.
      alert('배터리를 선택해 주세요!');
      navigate(`${DiagnosisPageUrl}?activeTab=0`); // DiagnosisPage의 첫 번째 탭으로 이동
    }
  }, [navigate]);

  // batteryId가 변경되면 getBatteryOverview를 호출하여 배터리 정보를 가져옵니다.
  useEffect(() => {
    if (batteryId) {
      fetchBatteryImages(batteryId, imagePage);
      fetchBatteryImageAll(batteryId, imagePage);
      fetchBatteryOverviewData(batteryId); // fetchBatteryOverviewData 함수 호출
      fetchBatteryDamageInfoData(batteryId);
    }
  }, [batteryId]); // batteryId가 변경될 때마다 호출

  useEffect(() => {
    if (batteryDamageInfo) {
      setBatteryFormData({
        carNo: batteryDamageInfo.info.carNo || '',
        romId: batteryDamageInfo.info.romId || '',
        productNo: batteryDamageInfo.info.productNo || '',
        productionDate: batteryDamageInfo.info.productionDate || '',
        qrcode: batteryDamageInfo.info.qrcode || '',
        price: batteryDamageInfo.damage.price || 0,
        breakage: batteryDamageInfo.damage.breakage || '',
        moisture: batteryDamageInfo.damage.moisture || '',
        pollution: batteryDamageInfo.damage.pollution || '',
        note: batteryDamageInfo.damage.note || '',
      });
    }
  }, [batteryDamageInfo]);

  const fetchBatteryOverviewData = (batteryId: string) => {
    SellerBatteryService.getBatteryOverview(batteryId)
      .then((data) => {
        setBatteryOverview(data.data); // 데이터를 상태에 저장
      })
      .catch((error) => {
        console.error('배터리 정보 조회 실패:', error);
      });
  };

  const fetchBatteryDamageInfoData = (batteryId: string) => {
    SellerBatteryService.getBatteryDamageInfo(batteryId)
      .then((data) => {
        setBatteryDamageInfo(data.data); // 데이터를 상태에 저장
      })
      .catch((error) => {
        console.error('배터리 기본 정보 조회 실패:', error);
      });
  };

  // 배터리 이미지 데이터 가져오기
  const fetchBatteryImages = (batteryId: string, imagePage: number) => {
    SellerBatteryService.getBatteryImages(batteryId, imagePage, 10)
      .then((response) => {
        const images = response.data.content; // API 응답에서 이미지 배열 가져오기
        setBatteryImages(images); // 상태를 업데이트
        setImageTotalPage(response.data.totalPages);
        setRepresentativeImage(response.data.representativeImage);

        // Representative Image가 있으면 설정하고, 없으면 첫 번째 이미지를 선택
        if (response.data.representativeImage) {
          setRepresentativeImage(response.data.representativeImage);
        } else if (images.length > 0) {
          setSelectedImage(images[0]); // 첫 번째 이미지를 선택
        }
      })
      .catch((error) => console.error('배터리 이미지 조회 실패:', error));
  };

  const fetchBatteryImageAll = (batteryId: string, imagePage: number) => {
    SellerBatteryService.getBatteryImages(batteryId, imagePage, 30)
      .then((response) => {
        const images = response.data.content; // API 응답에서 이미지 배열 가져오기
        setBatteryImageAll(images); // 상태를 업데이트
      })
      .catch((error) => console.error('배터리 이미지 조회 실패:', error));
  };

  const handleSave = async () => {
    try {
      if (!batteryId) {
        alert('배터리 ID가 없습니다.');
        return;
      }

      await SellerBatteryService.updateBatteryDamageInfo(
        batteryId,
        batteryFormData
      );
      alert('배터리 정보가 성공적으로 업데이트되었습니다.');
    } catch (error) {
      console.error('배터리 정보 저장 실패:', error);
      alert('배터리 정보를 저장하는 데 실패했습니다.');
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setBatteryFormData((prevData) => {
      // `price` 필드만 숫자만 허용
      if (name === 'price') {
        const numericValue = parseInt(value.replace(/[^0-9]/g, ''), 10) || 0; // 숫자로 변환
        return {
          ...prevData,
          [name]: numericValue, // 숫자 타입으로 저장
        };
      }

      // 다른 필드는 그대로 처리
      return {
        ...prevData,
        [name]: value,
      };
    });
  };

  // 숫자를 천 단위로 포맷하는 함수
  const formatNumber = (number: string | number): string => {
    if (!number) return '';
    return Number(number).toLocaleString();
  };

  const handleDownloadPDF = async () => {
    if (batteryDamageInfo && batteryOverview && batteryImages) {
      try {
        setIsPDFLoading(true); // 로딩 시작
        const pdfBytes = await generateDiagnosisTab2PDF(
          batteryDamageInfo,
          batteryOverview,
          batteryImageAll
        ); // PDF 생성
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = '진단정보_진단보고서.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('PDF 생성 중 오류 발생:', error);
      } finally {
        setIsPDFLoading(false); // 로딩 종료
      }
    }
  };

  const handleImageClick = (batteryImage: BatteryImage) => {
    setSelectedImage(batteryImage); // 선택된 이미지 설정
  };

  const handleScrollLeft = (batteryId: string) => {
    if (imagePage > 0) {
      const newPage = imagePage - 1;
      setImagePage(newPage);
      fetchBatteryImages(batteryId, newPage);
    }
  };

  const handleScrollRight = (batteryId: string) => {
    if (imagePage < imageTotalPage - 1) {
      // 현재 페이지가 총 페이지보다 작을 때만 이동
      const newPage = imagePage + 1;
      setImagePage(newPage);
      fetchBatteryImages(batteryId, newPage);
    }
  };

  const handleSetRepresentativeImage = async () => {
    if (!selectedImage || !selectedImage.batteryImageId || !batteryId) {
      alert('대표 이미지를 선택해주세요.');
      return;
    }

    try {
      await SellerBatteryService.updateRepresentativeImage(
        batteryId,
        selectedImage.batteryImageId
      );
      alert('대표 이미지가 성공적으로 등록되었습니다.');
    } catch (error) {
      console.error('대표 이미지 등록 실패:', error);
      alert(error);
    }
  };

  return (
    <Container>
      {isPDFLoading && <LoadingOverlay />}
      {/* 기본 정보 및 외부 손상 상태 */}
      <HeaderSection>
        <HeaderInfoBox>
          <TitleContainer>
            <Title>기본정보</Title>
            <ButtonContainerM>
              {localStorage.getItem('permissions') === 'SELLER' && (
                <Button save={true} onClick={handleSave}>
                  저장
                </Button>
              )}
              <ExportButton onClick={handleDownloadPDF} />
            </ButtonContainerM>
          </TitleContainer>
          <InfoBox>
            <InputContainer>
              <label>제조사</label>
              <input
                type="text"
                value={batteryDamageInfo?.info.manufacturer || ''}
                readOnly
              />
            </InputContainer>
            <InputContainer>
              <label>차종</label>
              <input
                type="text"
                value={batteryDamageInfo?.info.model || ''}
                readOnly
              />
            </InputContainer>
            <InputContainer>
              <label>측정일</label>
              <input
                type="text"
                value={batteryDamageInfo?.info.measurementDate || ''}
                readOnly
              />
            </InputContainer>
            <InputContainer>
              <label>ROM ID</label>
              <input
                type="text"
                name="romId"
                value={batteryFormData.romId || ''}
                onChange={handleInputChange}
              />
            </InputContainer>
            <InputContainer>
              <label>제품번호</label>
              <input
                type="text"
                name="productNo"
                value={batteryFormData.productNo || ''}
                onChange={handleInputChange}
              />
            </InputContainer>
            <InputContainer>
              <label>생산일</label>
              <input
                type="date"
                name="productionDate"
                value={batteryFormData.productionDate || ''}
                onChange={handleInputChange}
              />
            </InputContainer>
            <InputContainer>
              <label>차량번호</label>
              <input
                type="text"
                name="carNo"
                value={batteryFormData.carNo || ''}
                onChange={handleInputChange}
              />
            </InputContainer>
            <InputContainer>
              <label>QR CODE</label>
              <input
                type="text"
                name="qrcode"
                value={batteryFormData.qrcode || ''}
                onChange={handleInputChange}
              />
            </InputContainer>
          </InfoBox>
        </HeaderInfoBox>
        <HeaderInfoBox2>
          <TitleContainer>
            <Title>외부 손상상태 및 판매금액</Title>
            <ButtonContainer>
              {localStorage.getItem('permissions') === 'SELLER' && (
                <Button save={true} onClick={handleSave}>
                  저장
                </Button>
              )}
              <ExportButton onClick={handleDownloadPDF} />
            </ButtonContainer>
          </TitleContainer>
          <InfoBox2>
            <InputContainer2>
              <label>판매금액</label>
              <input
                type="text"
                name="price"
                value={formatNumber(batteryFormData.price)} // 천 단위 구분 추가
                onChange={handleInputChange}
              />
            </InputContainer2>
            <InfoGrid>
              <InputContainer2>
                <label>파손</label>
                <input
                  type="text"
                  name="breakage"
                  value={batteryFormData.breakage || ''}
                  onChange={handleInputChange}
                />
              </InputContainer2>
              <InputContainer2>
                <label>수분</label>
                <input
                  type="text"
                  name="moisture"
                  value={batteryFormData.moisture || ''}
                  onChange={handleInputChange}
                />
              </InputContainer2>
              <InputContainer2>
                <label>오염</label>
                <input
                  type="text"
                  name="pollution"
                  value={batteryFormData.pollution || ''}
                  onChange={handleInputChange}
                />
              </InputContainer2>
              <InputContainer2>
                <label>비고</label>
                <input
                  type="text"
                  name="note"
                  value={batteryFormData.note || ''}
                  onChange={handleInputChange}
                />
              </InputContainer2>
            </InfoGrid>
          </InfoBox2>
        </HeaderInfoBox2>
      </HeaderSection>

      {/* 측정 결과 및 외관 사진 */}
      <BodySection>
        <BodyInfoBox>
          <TitleContainer>
            <Title>
              <img src={leaf} alt="leaf" />
              측정결과
            </Title>
          </TitleContainer>
          <TableContainer>
            <Table>
              <thead>
                <tr>
                  <th>NO</th>
                  <th>진단 항목</th>
                  <th>상태</th>
                  <th>결과</th>
                  <th>단위</th>
                </tr>
              </thead>
              <tbody>
                {batteryOverview.map((overview, index) => (
                  <tr key={index}>
                    <td>{overview.overviewNo}</td>
                    <td>{overview.name}</td>
                    <td>
                      <StatusButton $status={overview.status}>
                        {overview.status}
                      </StatusButton>
                    </td>
                    <td>{overview.result}</td>
                    <td>{overview.unit}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableContainer>
        </BodyInfoBox>
        <BodyInfoBox>
          <TitleContainer>
            <Title>
              <img src={leaf} alt="leaf" />
              외관사진
            </Title>
          </TitleContainer>
          {batteryImages.length === 0 && <div>이미지가 없습니다.</div>}
          <BigImage>
            {representativeImage ? (
              <MemoizedImagePreview
                key={representativeImage.originalUrl}
                image={representativeImage}
                alt="대표 이미지"
              />
            ) : (
              selectedImage && (
                <MemoizedImagePreview
                  key={selectedImage.batteryImageId}
                  image={selectedImage.info}
                  alt={`배터리 이미지 ${selectedImage.batteryImageId}`}
                />
              )
            )}
          </BigImage>
          {batteryImages.length > 0 && (
            <MainImageButtonContainer>
              {localStorage.getItem('permissions') === 'SELLER' && (
                <>
                  <p>하단 이미지에서 대표 이미지를 선택해 주세요</p>
                  <Button save={true} onClick={handleSetRepresentativeImage}>
                    대표이미지 등록
                  </Button>
                </>
              )}
            </MainImageButtonContainer>
          )}
          {batteryImages.length > 0 && (
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
              }}
            >
              <ImageContainer>
                <ArrowButtonLeft
                  $disabled={imagePage === 0}
                  onClick={() => {
                    if (imagePage > 0) handleScrollLeft(batteryId || '');
                  }}
                >
                  <IoIosArrowBack />
                </ArrowButtonLeft>
                <ImageGrid>
                  {batteryImages.map((image, index) => (
                    <MemoizedImagePreview
                      small={true}
                      onClick={() => handleImageClick(image)}
                      key={
                        image.batteryImageId
                          ? image.batteryImageId
                          : `fallback-${index}`
                      }
                      image={image.info}
                      alt={`배터리 이미지 ${image.batteryImageId}`}
                    />
                  ))}
                </ImageGrid>
                <ArrowButtonRight
                  $disabled={imagePage >= imageTotalPage - 1}
                  onClick={() => {
                    if (imagePage < imageTotalPage - 1)
                      handleScrollRight(batteryId || '');
                  }}
                >
                  <IoIosArrowForward />
                </ArrowButtonRight>
              </ImageContainer>
            </div>
          )}
        </BodyInfoBox>
      </BodySection>
    </Container>
  );
}

export default DiagnosisTab2;
